<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: wjb
 * @Date: 2022-11-07 11:17:21
 * @LastEditors: wjb
 * @LastEditTime: 2025-11-20 13:57:41
-->
<template>
  <div class="wrapper" id="wrapper">
    <div class="tabline">
      <div class="headBox flex-c">
        <img src="@/static/img/logoNew.png" class="img" />
        <div class="headTitle">aijinhua</div>
      </div>
      <div class="tabs">
        <div
          class="tab"
          v-for="(item, i) in tabs"
          :key="i"
          :class="tabIndex == i ? 'tab-active' : ''"
          @click="changeTab(i)"
        >
          <router-link :to="item.url">{{ item.name }}</router-link>
        </div>
        <a v-if="isTest" class="tab" href="http://192.168.110.174:9112/entry" target="_blank">开发者门户</a>
        <a v-if="!isTest" class="tab" href="https://www.aijinhua.cn:7443/sysAdmin/entry" target="_blank">开发者门户</a>
      </div>
    </div>
    <router-view />
    <div class="footerbox">
      <div class="blackLine">
        <div class="left">
          <div class="title">{{ data.title }}</div>
          <div>地址：{{ data.address }}</div>
          <div>电话：{{ data.phone }}</div>
          <div>邮箱：{{ data.email }}</div>
          <div>备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color: #b0afaf; text-decoration: none;">浙ICP备2023047490号-2</a></div>
        </div>
        <div class="right">
          <div>
            <div class="title">企业介绍</div>
            <div v-for="(item, i) in footerTab1" :key="i" @click="changeFTab1(i)">
              <router-link :to="item.url">{{ item.name }}</router-link>
            </div>
          </div>
          <div style="margin-left: 123px">
            <div class="title">服务范围</div>
            <div v-for="(item, i) in footerTab2" :key="i" @click="changeFTab2(i)">
              <router-link :to="item.url">{{ item.name }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainLayout',
  components: {},
  data() {
    return {
      tabIndex: 0,
      tabs: [
        { name: '首页', url: '/' },
        { name: '通知公告', url: '/notice' },
        { name: '使用指南', url: '/guideline' },
        { name: '常见问题', url: '/question' },
        { name: '关于我们', url: '/about' },
        { name: '搜索', url: '/search' },
      ],
      data: {
        title: '数字金华技术运营有限公司',
        address: '浙江省金华市婺城区西关街道四联路398号金华网络经济中心大楼11楼',
        phone: '010-00000000',
        email: 's****8@163.com',
      },
      footerTab1: [
        { name: '首页', url: '/' },
        { name: '关于我们', url: '/about' },
      ],
      footerTab2: [
        { name: '通知公告', url: '/notice' },
        { name: '使用指南', url: '/guideline' },
        { name: '常见问题', url: '/question' },
      ],
      isTest: true,
    }
  },
  created() {
    this.tabIndex = sessionStorage.getItem('current_tab') ? sessionStorage.getItem('current_tab') : 0
    if (process.env.NODE_ENV === 'development') {
      this.isTest = true
    } else {
      this.isTest = false
    }
  },
  mounted() {},
  watch: {},
  methods: {
    changeTab(i) {
      this.tabIndex = i
      sessionStorage.setItem('current_tab', this.tabIndex)
    },
    changeFTab1(i) {
      if (i === 0) {
        this.tabIndex = 0
      } else {
        this.tabIndex = 4
      }
      sessionStorage.setItem('current_tab', this.tabIndex)
    },
    changeFTab2(i) {
      if (i === 0) {
        this.tabIndex = 1
      } else if (i === 1) {
        this.tabIndex = 2
      } else if (i === 2) {
        this.tabIndex = 3
      }
      sessionStorage.setItem('current_tab', this.tabIndex)
    },
  },
}
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  background-size: cover;
  position: relative;
  .tabline {
    width: 100%;
    height: 100px;
    background: #fafafa;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.19);
    padding: 0 350px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .headBox{
      .img{
        width: 56px;
        height: 56px;
      }
      .headTitle{
        margin-left:16px;
        font-size: 30px;
        font-weight: bold;
      }
    }
    .tabs {
      display: flex;
      a {
        color: #000;
        text-decoration: none;
        font-size: 24px;
        line-height: 36px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }
      .tab {
        width: 120px;
        height: 40px;
        border-radius: 10px;
        margin-left: 10px;
        text-align: center;
      }
    }
  }
  .footerbox {
    width: 100%;
    .blackLine {
      width: 100%;
      height: 260px;
      background: #222222;
      padding: 0 350px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      line-height: 30px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #b0afaf;
      .right {
        display: flex;
        a {
          font-size: 16px;
          line-height: 30px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #b0afaf;
          text-decoration: none;
        }
      }
      .title {
        font-size: 24px;
        font-weight: 400;
        color: #b0afaf;
        margin-bottom: 32px;
      }
    }
  }
}
.tab-active {
  background-color: #428ffc !important;
  a {
    color: white !important;
  }
}
.flex-c {
  display: flex;
  align-items: center;
}
</style>
